// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { settleMount } from "#ce/framework/mount-ready";

/** Returns the element a schedule-form container names (a selector or an element); throws a TypeError for anything else. */
export function resolveScheduleRoot(container) {
  if (typeof container === "string") {
    return document.querySelector(container);
  }

  if (container instanceof Element) {
    return container;
  }

  throw new TypeError("ScheduleForm expects a selector or an Element");
}

/** Returns a check that tells whether a recurrence select now holds a different type than the root's select last did. */
export function createRecurrenceTracker(root) {
  const recurrenceControl = root?.querySelector("[data-behaviour~=update-repeat-select]");
  let currentRecurrenceType;

  function rememberRecurrence(mounted) {
    if (!mounted) {
      return;
    }

    currentRecurrenceType = recurrenceControl.value;
  }

  function recurrenceChanged(control) {
    if (currentRecurrenceType == control.value) {
      return false;
    }

    currentRecurrenceType = control.value;

    return true;
  }

  settleMount(recurrenceControl).then(rememberRecurrence);

  return recurrenceChanged;
}
